/**
 * CRM Multi-Compagnia · Dashboard - ChartContainer
 * Wrapper standardizzato per i grafici: titolo, sottotitolo, loading,
 * empty state, errore + slot per il chart.
 */
import { Spinner } from "@/components/crm-multi/shared";
import { Inbox } from "lucide-react";

export default function ChartContainer({ title, subtitle, loading, error, isEmpty, emptyHint, children, action, testid, fullHeight = false }) {
  return (
    <div className={`bg-white border border-zinc-200 rounded-xl p-4 ${fullHeight ? "h-full flex flex-col" : ""}`} data-testid={testid}>
      <header className="flex items-start justify-between mb-3 gap-2">
        <div className="min-w-0">
          <h3 className="text-sm font-semibold text-zinc-900 truncate">{title}</h3>
          {subtitle && <p className="text-[11px] text-zinc-500 mt-0.5">{subtitle}</p>}
        </div>
        {action && <div className="flex-shrink-0">{action}</div>}
      </header>
      <div className={fullHeight ? "flex-1 min-h-0" : ""}>
        {loading ? (
          <div className="py-10 flex justify-center"><Spinner /></div>
        ) : error ? (
          <p className="text-xs text-rose-600 text-center py-8">{typeof error === "string" ? error : JSON.stringify(error)}</p>
        ) : isEmpty ? (
          <div className="text-center py-10 text-zinc-400">
            <Inbox className="w-6 h-6 mx-auto mb-2" />
            <p className="text-xs">{emptyHint || "Nessun dato disponibile"}</p>
          </div>
        ) : children}
      </div>
    </div>
  );
}
